export const environment = {
  production: false,
  apiBaseUrl: 'https://api.ainalthiqah.shop/api',
  appName: 'Dev Thiqah Tech',
  enableDebug: true
};
